import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "reviewView" }

import { onMounted, ref, watchEffect } from "vue";
import {
  Post,
  PostCommentControllerService,
  PostControllerService,
  WriteUpControllerService,
} from "../../generated";
import message from "@arco-design/web-vue/es/message";
import { useRouter } from "vue-router";
import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewView',
  setup(__props) {

const dataList = ref({
  postUnaudited: [],
  postAudited: [],
  postCommentUnaudited: [],
  postCommentAudited: [],
  writeUpUnaudited: [],
  writeUpAudited: [],
});
const totalList = ref({
  postUnaudited: 0,
  postAudited: 0,
  postCommentUnaudited: 0,
  postCommentAudited: 0,
  writeUpUnaudited: 0,
  writeUpAudited: 0,
});
const searchParams = ref({
  postUnaudited: {
    pageSize: 10,
    current: 1,
    title: "",
    tag: [],
    reviewStatus: 0,
  },
  postAudited: {
    pageSize: 10,
    current: 1,
    title: "",
    tag: [],
    notReviewStatus: 0,
  },
  postCommentUnaudited: {
    pageSize: 10,
    current: 1,
    title: "",
    reviewStatus: 0,
  },
  postCommentAudited: {
    pageSize: 10,
    current: 1,
    title: "",
    notReviewStatus: 0,
  },
  writeUpUnaudited: {
    pageSize: 10,
    current: 1,
    title: "",
    tag: [],
    reviewStatus: 0,
  },
  writeUpAudited: {
    pageSize: 10,
    current: 1,
    title: "",
    tag: [],
    notReviewStatus: 0,
  },
});

const loadData = async () => {
  // 校验分页数量
  if (
    !searchParams.value.postUnaudited.pageSize ||
    searchParams.value.postUnaudited.pageSize <= 0
  ) {
    searchParams.value.postUnaudited.pageSize = 5;
  }
  let res = await PostControllerService.listPostVoByPageUsingPost(
    searchParams.value.postUnaudited
  );
  if (res.code === 0) {
    dataList.value.postUnaudited = res.data.records;
    totalList.value.postUnaudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
  // 校验分页数量
  if (
    !searchParams.value.postAudited.pageSize ||
    searchParams.value.postAudited.pageSize <= 0
  ) {
    searchParams.value.postAudited.pageSize = 5;
  }
  res = await PostControllerService.listPostVoByPageUsingPost(
    searchParams.value.postAudited
  );
  if (res.code === 0) {
    dataList.value.postAudited = res.data.records;
    totalList.value.postAudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }

  // 校验分页数量
  if (
    !searchParams.value.postCommentUnaudited.pageSize ||
    searchParams.value.postCommentUnaudited.pageSize <= 0
  ) {
    searchParams.value.postCommentUnaudited.pageSize = 5;
  }
  res = await PostCommentControllerService.listPostCommentVoByPageUsingPost(
    searchParams.value.postCommentUnaudited
  );
  if (res.code === 0) {
    dataList.value.postCommentUnaudited = res.data.records;
    totalList.value.postCommentUnaudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
  // 校验分页数量
  if (
    !searchParams.value.postCommentUnaudited.pageSize ||
    searchParams.value.postCommentUnaudited.pageSize <= 0
  ) {
    searchParams.value.postCommentUnaudited.pageSize = 5;
  }
  res = await PostCommentControllerService.listPostCommentVoByPageUsingPost(
    searchParams.value.postCommentUnaudited
  );
  if (res.code === 0) {
    dataList.value.postCommentAudited = res.data.records;
    totalList.value.postCommentAudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }

  // 校验分页数量
  if (
    !searchParams.value.writeUpUnaudited.pageSize ||
    searchParams.value.writeUpUnaudited.pageSize <= 0
  ) {
    searchParams.value.writeUpUnaudited.pageSize = 5;
  }
  res = await WriteUpControllerService.listWriteUpVoByPageUsingPost(
    searchParams.value.writeUpUnaudited
  );
  if (res.code === 0) {
    dataList.value.writeUpUnaudited = res.data.records;
    totalList.value.writeUpUnaudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
  // 校验分页数量
  if (
    !searchParams.value.writeUpAudited.pageSize ||
    searchParams.value.writeUpAudited.pageSize <= 0
  ) {
    searchParams.value.writeUpAudited.pageSize = 5;
  }
  res = await WriteUpControllerService.listWriteUpVoByPageUsingPost(
    searchParams.value.writeUpAudited
  );
  if (res.code === 0) {
    dataList.value.writeUpAudited = res.data.records;
    totalList.value.writeUpAudited = res.data.total;
  } else {
    message.error("加载数据失败！ " + res.message);
  }
};

onMounted(() => {
  loadData();
});
// 监听分页变量，改变时更新页面
watchEffect(() => {
  loadData();
});

const postColumns = [
  {
    title: "帖子ID",
    dataIndex: "postId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tag",
  },
  {
    title: "发布时间",
    slotName: "createTime",
  },
  {
    title: "审核结果",
    slotName: "reviewStatus",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];
// 跳转到帖子详情页面
const router = useRouter();
const toPost = (post: Post) => {
  router.push({
    path: `/view/post/${post.postId}`,
  });
};

const onPostUnauditedSearchParamsPageChange = (page: number) => {
  searchParams.value.postUnaudited = {
    ...searchParams.value.postUnaudited,
    current: page,
  };
};
const onPostAuditedSearchParamsPageChange = (page: number) => {
  searchParams.value.postAudited = {
    ...searchParams.value.postAudited,
    current: page,
  };
};

const postCommentColumns = [
  {
    title: "评论ID",
    dataIndex: "postCommentId",
  },
  {
    title: "内容",
    dataIndex: "content",
  },
  {
    title: "发布时间",
    slotName: "createTime",
  },
  {
    title: "审核结果",
    slotName: "reviewStatus",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];
const onPostCommentUnauditedSearchParamsPageChange = (page: number) => {
  searchParams.value.postCommentUnaudited = {
    ...searchParams.value.postCommentUnaudited,
    current: page,
  };
};
const onPostCommentAuditedSearchParamsPageChange = (page: number) => {
  searchParams.value.postCommentAudited = {
    ...searchParams.value.postCommentAudited,
    current: page,
  };
};

const writeUpColumns = [
  {
    title: "题解ID",
    dataIndex: "writeUpId",
  },
  {
    title: "标题",
    dataIndex: "title",
  },
  {
    title: "标签",
    slotName: "tag",
  },
  {
    title: "发布时间",
    slotName: "createTime",
  },
  {
    title: "审核结果",
    slotName: "reviewStatus",
  },
  {
    title: "操作",
    slotName: "optional",
  },
];

const onWriteUpUnauditedSearchParamsPageChange = (page: number) => {
  searchParams.value.writeUpUnaudited = {
    ...searchParams.value.writeUpUnaudited,
    current: page,
  };
};
const onWriteUpAuditedSearchParamsPageChange = (page: number) => {
  searchParams.value.writeUpAudited = {
    ...searchParams.value.writeUpAudited,
    current: page,
  };
};

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_IconFile = _resolveComponent("IconFile")!
  const _component_a_badge = _resolveComponent("a-badge")!
  const _component_IconMessage = _resolveComponent("IconMessage")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_IconCodeBlock = _resolveComponent("IconCodeBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[32] || (_cache[32] = _createElementVNode("h2", { style: {"margin-bottom":"32px"} }, "审核", -1)),
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: loadData,
      style: {"margin-bottom":"16px","width":"100px"}
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("刷新数据")
      ])),
      _: 1
    }),
    _createVNode(_component_a_tabs, { "default-active-key": "0" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_tab_pane, { key: "0" }, {
          title: _withCtx(() => [
            _createVNode(_component_a_badge, {
              count: totalList.value.postUnaudited
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconFile),
                _cache[7] || (_cache[7] = _createTextVNode(" 主题帖  "))
              ]),
              _: 1
            }, 8, ["count"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              class: "left-tabs",
              "default-active-key": "0",
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, { key: "0" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_a_badge, {
                      count: totalList.value.postUnaudited,
                      class: "left-tab-pane"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconMessage),
                        _cache[8] || (_cache[8] = _createTextVNode(" 待审核  "))
                      ]),
                      _: 1
                    }, 8, ["count"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[9] || (_cache[9] = _createTextVNode("每页帖子数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.postUnaudited.pageSize,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.postUnaudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页帖子数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: postColumns,
                      data: dataList.value.postUnaudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.postUnaudited.pageSize,
                current: searchParams.value.postUnaudited.current,
                total: totalList.value.postUnaudited,
              },
                      onPageChange: onPostUnauditedSearchParamsPageChange
                    }, {
                      postId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.postId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      tag: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_tag, {
                                key: index,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      optional: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: ($event: any) => (_unref(router).push(`/review/post/${record.postId}`))
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode(" 去审核 ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  title: "已审核"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_IconMessage),
                    _cache[11] || (_cache[11] = _createTextVNode(" 已审核  "))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[12] || (_cache[12] = _createTextVNode("每页帖子数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.postAudited.pageSize,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.postAudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页帖子数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: postColumns,
                      data: dataList.value.postAudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.postAudited.pageSize,
                current: searchParams.value.postAudited.current,
                total: totalList.value.postAudited,
              },
                      onPageChange: onPostAuditedSearchParamsPageChange
                    }, {
                      postId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.postId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      tag: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_tag, {
                                key: index,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      reviewStatus: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            (record.reviewStatus === 1)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 0,
                                  color: "green"
                                }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode("已通过")
                                  ])),
                                  _: 1
                                }))
                              : (record.reviewStatus === 2)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                      _createTextVNode("已退回")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      optional: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: ($event: any) => (toPost(record))
                            }, {
                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                _createTextVNode("查看详情 ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, { key: "1" }, {
          title: _withCtx(() => [
            _createVNode(_component_a_badge, {
              count: totalList.value.postCommentUnaudited
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconMessage),
                _cache[16] || (_cache[16] = _createTextVNode(" 评论  "))
              ]),
              _: 1
            }, 8, ["count"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              class: "left-tabs",
              "default-active-key": "0",
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, { key: "0" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_a_badge, {
                      count: totalList.value.postCommentUnaudited,
                      class: "left-tab-pane"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconMessage),
                        _cache[17] || (_cache[17] = _createTextVNode(" 待审核 "))
                      ]),
                      _: 1
                    }, 8, ["count"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[18] || (_cache[18] = _createTextVNode("每页评论数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.postCommentUnaudited.pageSize,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.postCommentUnaudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页评论数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: postCommentColumns,
                      data: dataList.value.postCommentUnaudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.postCommentUnaudited.pageSize,
                current: searchParams.value.postCommentUnaudited.current,
                total: totalList.value.postCommentUnaudited,
              },
                      onPageChange: onPostCommentUnauditedSearchParamsPageChange
                    }, {
                      postCommentId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.postCommentId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      optional: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: ($event: any) => (
                      _unref(router).push(`/review/postComment/${record.postCommentId}`)
                    )
                            }, {
                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                _createTextVNode(" 去审核 ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  title: "已审核"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_IconMessage),
                    _cache[20] || (_cache[20] = _createTextVNode(" 已审核  "))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[21] || (_cache[21] = _createTextVNode("每页评论数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.postCommentAudited.pageSize,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.postCommentAudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页评论数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: postCommentColumns,
                      data: dataList.value.postCommentAudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.postCommentAudited.pageSize,
                current: searchParams.value.postCommentAudited.current,
                total: totalList.value.postCommentAudited,
              },
                      onPageChange: onPostCommentAuditedSearchParamsPageChange
                    }, {
                      postCommentId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.postCommentId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      reviewStatus: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            (record.reviewStatus === 1)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 0,
                                  color: "green"
                                }, {
                                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                                    _createTextVNode("已通过")
                                  ])),
                                  _: 1
                                }))
                              : (record.reviewStatus === 2)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                                      _createTextVNode("已退回")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tab_pane, { key: "2" }, {
          title: _withCtx(() => [
            _createVNode(_component_a_badge, {
              count: totalList.value.writeUpUnaudited
            }, {
              default: _withCtx(() => [
                _createVNode(_component_IconCodeBlock),
                _cache[24] || (_cache[24] = _createTextVNode(" 题解  "))
              ]),
              _: 1
            }, 8, ["count"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              class: "left-tabs",
              "default-active-key": "0",
              direction: "vertical"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, { key: "0" }, {
                  title: _withCtx(() => [
                    _createVNode(_component_a_badge, {
                      count: totalList.value.writeUpUnaudited,
                      class: "left-tab-pane"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconMessage),
                        _cache[25] || (_cache[25] = _createTextVNode(" 待审核  "))
                      ]),
                      _: 1
                    }, 8, ["count"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[26] || (_cache[26] = _createTextVNode("每页题解数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.writeUpUnaudited.pageSize,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchParams.value.writeUpUnaudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页题解数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: writeUpColumns,
                      data: dataList.value.writeUpUnaudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.writeUpUnaudited.pageSize,
                current: searchParams.value.writeUpUnaudited.current,
                total: totalList.value.writeUpUnaudited,
              },
                      onPageChange: onWriteUpUnauditedSearchParamsPageChange
                    }, {
                      writeUpId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.writeUpId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      tag: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_tag, {
                                key: index,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      optional: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: ($event: any) => (_unref(router).push(`/review/writeUp/${record.writeUpId}`))
                            }, {
                              default: _withCtx(() => _cache[27] || (_cache[27] = [
                                _createTextVNode(" 去审核 ")
                              ])),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "1",
                  title: "已审核"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_IconMessage),
                    _cache[28] || (_cache[28] = _createTextVNode(" 已审核  "))
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_space, null, {
                      default: _withCtx(() => [
                        _cache[29] || (_cache[29] = _createTextVNode("每页题解数量 ")),
                        _createVNode(_component_a_input_number, {
                          modelValue: searchParams.value.writeUpAudited.pageSize,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((searchParams.value.writeUpAudited.pageSize) = $event)),
                          min: "1",
                          placeholder: "每页题解数量",
                          size: "small",
                          style: {"width":"200px"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_divider, { size: 0 }),
                    _createVNode(_component_a_table, {
                      columns: writeUpColumns,
                      data: dataList.value.writeUpAudited,
                      pagination: {
                showTotal: true,
                pageSize: searchParams.value.writeUpAudited.pageSize,
                current: searchParams.value.writeUpAudited.current,
                total: totalList.value.writeUpAudited,
              },
                      onPageChange: onWriteUpAuditedSearchParamsPageChange
                    }, {
                      writeUpId: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(record.writeUpId), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      tag: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, { wrap: "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.tag, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_tag, {
                                key: index,
                                color: "green"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item), 1)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      createTime: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD-HH:MM:SS")), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      reviewStatus: _withCtx(({ record }) => [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            (record.reviewStatus === 1)
                              ? (_openBlock(), _createBlock(_component_a_tag, {
                                  key: 0,
                                  color: "green"
                                }, {
                                  default: _withCtx(() => _cache[30] || (_cache[30] = [
                                    _createTextVNode("已通过")
                                  ])),
                                  _: 1
                                }))
                              : (record.reviewStatus === 2)
                                ? (_openBlock(), _createBlock(_component_a_tag, {
                                    key: 1,
                                    color: "red"
                                  }, {
                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                      _createTextVNode("已退回")
                                    ])),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }, 8, ["data", "pagination"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})